<script>
import api from "@/axios";
import Loader from "../components/loader";
import Layout from '../../layouts/main'
import PageHeader from '@/components/page-header'
import ProjetosTable from './projetos-table.vue'
import appConfig from "@/app.config";
import {condicoesChart1, condicoesChart2 } from "../components/data-simulados";
import { Vue3Lottie } from 'vue3-lottie'
import 'vue3-lottie/dist/style.css'
import AstronautJSON from '@/assets/animations/projetos_anim.json'
import exportFromJSON from "export-from-json"
import {getBaseUrl} from "@/helpers/baseUrl";

export default {
  page: {
    title: "Projetos",
    meta: [{ descricao: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader, ProjetosTable, Loader, Vue3Lottie },
  data() {
    return {
      AstronautJSON,

      title: 'Projetos',
      items: [
        {
          text: 'Administrativo',
          href: '/',
        },
        {
          text: 'Projetos',
          active: true,
        },
      ],
      errosValid: null,
      loadingList: true,
      loadingGraph: true,
      projetosList: null,
      projChart1: condicoesChart1,
      projChart2: condicoesChart2,
      pesqTextFilter: '',
      statusFilter: 'T',

    }
  },
  methods: {

    gestaoProjetos() {
      console.log('gestaoProjetos')
      this.$router.push('/projetos/listnv')
    },

    exportExcel(){
      console.log('exportExcel')
      const data = this.projetosList
      const fileName = "exp_dados";
      const exportType = exportFromJSON.types.xls;
      if (data) exportFromJSON({ data, fileName, exportType });
    },

    atualizaDataList(){
      this.loadingList = true
      api.get(`${getBaseUrl()}api/projetos`, {
        params: {
          'q': this.pesqTextFilter,
          's': this.statusFilter
        }
      }).then((res) => {
        console.log('then axios')
        // console.log(res.data)
        if (res.data.error){
          console.log(res.data.error)
          this.$router.push(`/faltapermissao`);
        }else{
          this.projetosList = res.data[0]
          this.title = `(${this.projetosList.length}) Projetos`
          this.loadingList = false
          this.loadingGraph = false
        }
      });
    },
  },
  mounted() {
    console.log('mounted projetos-list_0')
    this.atualizaDataList()
  },
}
</script>

<template>

  <Layout>

    <span class="float-end" style="z-index: 1000; position: absolute; top: 50px; right: 200px;">
      <Vue3Lottie :animationData="AstronautJSON" :height="200" :width="200" />
    </span>

    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mb-2">

              <div class="col-sm-2">
                <div class="search-box me-2 mb-2 d-inline-block">
                  <div class="position-relative">
                    <input
                        id="inputPesquisa"
                        type="text"
                        v-model="pesqTextFilter"
                        class="form-control"
                        placeholder="Enter para pesquisar..."
                        @change="atualizaDataList"/>
                    <i class="bx bx-search-alt search-icon"></i>
                  </div>
                </div>
              </div>

              <div class="col-sm-1">
                <div class="search-box me-2 mb-2 d-inline-block">
                  <div class="position-relative">
                    <select
                        id="selectStatus"
                        v-model="statusFilter"
                        @change="atualizaDataList"
                        class="form-control select2-search-disable">
                      <option value="T" selected>Todos</option>
                      <option value="AB">Aberto</option>
                      <option value="CO">Concluído</option>
                      <option value="CA">Cancelado</option>
                    </select>
                    <i class="bx bx-filter-alt search-icon"></i>
                  </div>
                </div>
              </div>

              <div class="col-sm-1">
                <div class="mb-2 d-inline-block">
                  <div class="position-relative">
                    <b-button variant="outline-primary" class="" @click="exportExcel">
                      <i class="bx bx-export font-size-16 align-middle "></i>
                    </b-button>
                  </div>
                </div>
              </div>

              <div class="col-sm-3">
                <div class="mb-2 d-inline-block">
                  <div class="position-relative">
                    <b-button variant="outline-warning" class="" @click="gestaoProjetos">
                      <i class="bx bx-shield font-size-16 align-middle "> Gestão </i>
                    </b-button>
                  </div>
                </div>
              </div>

              <div class="col-sm-5">
                <div class="text-sm-end">

                  <router-link :to="`/projeto/editar/0`">
                    <button type="button" class="btn btn-success btn-rounded mb-2 me-2" >
                      <i class="mdi mdi-plus me-1"></i> Novo Projeto
                    </button>
                  </router-link>

                </div>
              </div>
            </div>

            <Loader v-if="loadingList" style="min-height: 300px;">
            </Loader>

            <ProjetosTable
                ref="childTable"
                :projetosList="projetosList"
                />

            <ul class="pagination pagination-rounded justify-content-end mb-2">
              <li class="page-item disabled">
                <a class="page-link" href="javascript: void(0);" aria-label="Previous">
                  <i class="mdi mdi-chevron-left"></i>
                </a>
              </li>
              <li class="page-item active">
                <a class="page-link" href="javascript: void(0);">1</a>
              </li>

              <li class="page-item disabled">
                <a class="page-link" href="javascript: void(0);" aria-label="Next">
                  <i class="mdi mdi-chevron-right"></i>
                </a>
              </li>
            </ul>
          </div>

        </div>
      </div>
    </div>

    <b-alert v-for="(erro, i) in errosValid" :key="`alerta-${i}`"   show dismissible variant="danger" >
      <i class="mdi mdi-alert me-2"></i>Pendente validação de campo: {{ erro.titulo }} -- {{ erro.mensagem[0] }} --
      favor ajustar e tentar novamente.
    </b-alert>

    <Loader v-if="loadingGraph" style="min-height: 300px;">
    </Loader>

    <div class="row" v-if="!loadingGraph">
      <div class="col-lg-6">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-3">Projetos Destaque Mês</h4>
            <apexchart
                class="apex-charts"
                height="350"
                type="bar"
                dir="ltr"
                :series="projChart1.series"
                :options="projChart1.chartOptions"
            ></apexchart>
          </div>
        </div>
      </div>
      <div class="col-lg-6">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">Destaques Semana</h4>
            <apexchart
                class="apex-charts"
                height="320"
                type="donut"
                dir="ltr"
                :series="projChart2.series"
                :options="projChart2.chartOptions"
            ></apexchart>
          </div>
        </div>
      </div>
    </div>


  </Layout>
</template>
